import { defineStore } from "pinia";

import { ACTION_SESSION_HIDE_FILTERS, GETTER_SESSION_SHOULD_DISPLAY_FILTERS, ACTION_SESSION_SHOW_FILTERS } from "@etab/stores/types";

export const useSessionStore = defineStore("session", {
  // convert to a function
  state: () => ({
    shouldDisplayFilters: true,
  }),
  getters: {
    [GETTER_SESSION_SHOULD_DISPLAY_FILTERS]: (state) => state.shouldDisplayFilters,
  },
  actions: {
    [ACTION_SESSION_HIDE_FILTERS]() {
      this.shouldDisplayFilters = false;
    },
    [ACTION_SESSION_SHOW_FILTERS]() {
      this.shouldDisplayFilters = true;
    },
    // easily reset state using `$reset`
    clearSessionStore() {
      this.$reset();
    },
  },
});
